import * as React from 'react';
import BubbleDisplayer from './EyewearBubbleDisplayer/BubbleDisplayer';
import { WarningRow, WarningRowItem } from './EyewearWarning.css';

/* Components */
const EyewearWarning: React.FunctionComponent = () => (
  <WarningRow data-cy="eyewear-warning-row">
    <WarningRowItem data-cy="text">WARNING: California Proposition 65</WarningRowItem>
    <WarningRowItem>
      <BubbleDisplayer />
    </WarningRowItem>
  </WarningRow>
);

export default EyewearWarning;
